import { useState } from "react";
import { useRecoilState } from "recoil";
import { printHouseProfile } from "@/store/print-house-profile";
import { DOCUMENT_TYPE } from "@/pages-components/quotes/enums";
import { usePolling } from "@/hooks/polling/use-polling";
import { POLLING_INTERVALS } from "@/hooks/polling/polling-intervals";

const useDocumentsTableSocketIo = (documentType: DOCUMENT_TYPE) => {
  const [isSocketUpdateDocumentsTable, setIsSocketUpdateDocumentsTable] =
    useState<boolean>(false);
  const [printHouse] = useRecoilState(printHouseProfile);

  usePolling({
    enabled: !!printHouse?.id,
    intervalMs: POLLING_INTERVALS.documentsTable,
    events:
      printHouse?.id
        ? {
            [`updateDocumentTable-${printHouse.id}-${documentType}`]: () => {
              setIsSocketUpdateDocumentsTable(true);
            },
          }
        : {},
  });

  return {
    isSocketUpdateDocumentsTable,
    setIsSocketUpdateDocumentsTable,
  };
};

export { useDocumentsTableSocketIo };
